export const data = {
    logo_title: 'IXONANIMATION',
    menu:[
        {
            title: 'Work',
            link: '#work',
        },
        {
            title: 'About',
            link: '#about',
        },
        {
            title: 'Contact',
            link: '#contact',
        },
    ],
    banner: [
        {
            id: 1,
            title: 'Intiqam Huseynov - Showreel 2023',
            video: 'https://www.youtube.com/watch?v=WmXi9k5v7E4',
        },
        {
            id: 2,
            title: '',
            image: '/assets/images/banner.png',
        },
        // {
        //     title: '343rfwer',
        //     image: '/assets/images/banner1.png',
        // },
    ],
    work: [
        // {
        //     date: '31.Oct.2024',
        //     title: '',
        //     image: 'https://img.youtube.com/vi/9LS-o8tSA2g/sddefault.jpg',
        //     link: '',
        //     description: ``
        // },
        {
            date: '31.Oct.2024',
            title: ' GREEN SAF24 STEAM Azerbaijan Festival Presentation #cop29 ',
            image: 'https://img.youtube.com/vi/o9hSVpqGWH0/sddefault.jpg',
            link: 'https://www.youtube.com/watch?v=o9hSVpqGWH0',
            description: `With the support of the Ministry of Science and Education of the Republic of Azerbaijan, the International Green STEAM Azerbaijan Festival will be held in the Baku Expo Center on October 24-25, organized by the STEAM Azerbaijan project.`
        },
        {
            date: '31.Oct.2024',
            title: 'Halal Business and Tourism Forum AZHAB Azerbaijan',
            image: 'https://img.youtube.com/vi/4z6vzdXBCZU/sddefault.jpg',
            link: 'https://www.youtube.com/watch?v=4z6vzdXBCZU',
            description: `The initiative to launch the "Azerbaijan Halal Business"(AZHAB) Forum is grounded in Azerbaijan\`s proven regional role as the main locomotive driving its economic growth.`
        },
        {
            date: '31.Oct.2024',
            title: 'Expo Home Baku',
            image: 'https://img.youtube.com/vi/4eZwUEualz8/sddefault.jpg',
            link: 'https://www.youtube.com/watch?v=4eZwUEualz8',
            description: ``
        },
        {
            date: '31.Oct.2024',
            title: 'Expo Home Animation',
            image: 'https://img.youtube.com/vi/6-oAk27fDjU/sddefault.jpg',
            link: 'https://www.youtube.com/watch?v=6-oAk27fDjU',
            description: ``
        },
        {
            date: '31.Oct.2024',
            title: 'OLDSTONE SHOWREEL',
            image: 'https://img.youtube.com/vi/zCu6HXDCtjw/sddefault.jpg',
            link: 'https://www.youtube.com/watch?v=zCu6HXDCtjw',
            description: `Logo Concept :  Bulud Media <br /> Animation : Pixon Animation`
        },
        {
            date: '31.Oct.2024',
            title: 'SAF 2024 Logo Branding Presenataion',
            image: 'https://img.youtube.com/vi/9LS-o8tSA2g/sddefault.jpg',
            link: 'https://www.youtube.com/watch?v=9LS-o8tSA2g',
            description: `Logo Concept :  Bulud Media <br /> Animation : Pixon Animation`
        },
        {
            date: '17.Dec.2022',
            title: 'Darenka TV Reklam çarxı',
            image: 'https://img.youtube.com/vi/XJDeYSkCfZA/sddefault.jpg',
            link: 'https://www.youtube.com/watch?v=XJDeYSkCfZA',
            description: `Darenka product animation. In the current situation we and our clients need to deal with unique challenges. Our collaboration with the ads house Smile Agensy  resulted in a unique commercial.`
        },
        {
            date: '17.Dec.2022',
            title: 'LG Plus TVC Animation',
            image: 'https://img.youtube.com/vi/i6guuDiEQgM/sddefault.jpg',
            link: 'https://www.youtube.com/watch?v=i6guuDiEQgM',
            description: `CGİ - İNTİQAM HUSEYN,<br />
            CLIENT - LG PLUS,<br />
            AGENCY - FİLTİREX,<br />
            POSTPRODUCTION HOUSE - PİXON ANİMATİON.`
        },
        {
            date: '17.Dec.2022',
            title: '"Aromaks" 3D Animation',
            image: 'https://img.youtube.com/vi/fxcYXGXYxP4/sddefault.jpg',
            link: 'https://www.youtube.com/watch?v=fxcYXGXYxP4',
            description: `CGİ - İNTİQAM HUSEYN,<br />
            CLIENT - AROMAX,<br />
            POSTPRODUCTION HOUSE - PİXON ANİMATİON.`
        },
        {
            date: '12.Mar.2022',
            title: 'Avant Park CGI Animation',
            image: 'https://img.youtube.com/vi/Ho_6PHuiGRs/sddefault.jpg',
            link: 'https://www.youtube.com/watch?v=Ho_6PHuiGRs&t=53s',
            description: `CGİ - İNTİQAM HUSEYN,<br />
            CLIENT - AVANT PARK,<br />
            AGENCY - İNSTİNKT,<br />
            POSTPRODUCTION HOUSE - PİXON ANİMATİON.`
        },
        {
            date: '27.Mar.2022',
            title: 'Sakura TVC',
            image: 'https://img.youtube.com/vi/mQZ2AwkKeSs/sddefault.jpg',
            link: 'https://www.youtube.com/watch?v=mQZ2AwkKeSs',
            description: `Sakura product animation. Our collaboration with the ads house Smile Agensy  resulted in a unique commercial.`
        },
        {
            date: '05.Oct.2022',
            title: '"Filtrex" Su Filtiri TVC',
            image: 'https://i.ytimg.com/vi/1pKf3QqFTz8/0.jpg',
            link: 'https://www.youtube.com/watch?v=1pKf3QqFTz8',
            description: `CGİ - İNTİQAM HUSEYN,<br />
            AGENCY - FİLTİREX,<br />
            POSTPRODUCTION HOUSE - PİXON ANİMATİON.`
        },
        {
            date: '17.Dec.2022',
            title: 'LG Plus TVC Soft : 3ds Max, Cinema 4D & After Effects',
            image: 'https://img.youtube.com/vi/I0WphsBeJzk/sddefault.jpg',
            link: 'https://www.youtube.com/watch?v=I0WphsBeJzk',
            description: `CGİ - İNTİQAM HUSEYN,<br />
            AGENCY - FİLTİREX,<br />
            POSTPRODUCTION HOUSE - PİXON ANİMATİON.`
        },
        {
            date: '13.Jan.2022',
            title: 'Melchiori Product Animation Making Of',
            image: 'https://img.youtube.com/vi/kuGNjLexDfE/sddefault.jpg',
            link: 'https://www.youtube.com/watch?v=kuGNjLexDfE',
            description: `CGİ - İNTİQAM HUSEYN,<br />
            CLIENT - Melchiori<br />
            POSTPRODUCTION HOUSE - PİXON ANİMATİON.`
        },
        {
            date: '15.Mar.2022',
            title: 'GCF 2D Animation Presentation',
            image: 'https://img.youtube.com/vi/hFyqpiG-H2Q/sddefault.jpg',
            link: 'https://www.youtube.com/watch?v=hFyqpiG-H2Q',
            description: `CGİ - İNTİQAM HUSEYN,<br />
            AGENCY - NarimanFilms,<br />
            POSTPRODUCTION HOUSE - PİXON ANİMATİON.`
        },
        {
            date: '19.Sen.2018',
            title: 'Grand Palace 3D Animation',
            image: 'https://i.ytimg.com/vi/1YGSVqSEaMM/0.jpg',
            link: 'https://www.youtube.com/watch?v=1YGSVqSEaMM&t=24s',
            description: `CGİ - İNTİQAM HUSEYN,<br />
            CLIENT - GRAND PALACE<br />
            POSTPRODUCTION HOUSE - PİXON ANİMATİON.`
        },

    ]
};


export const bio = {
    name: 'Intigam Huseynov',
    email: [
        'pixon.animasiya@gmail.com',
        'innext.az@gmail.com'
    ],
    phone: [
        '+994 55 594 38 35'
    ],
    image: '/assets/images/intiqam.jpeg',
    links: [
        {
            icon: 'fab fa-facebook',
            link: 'https://www.facebook.com/profile.php?id=100086486737833'
        },
        {
            icon: 'fab fa-instagram-square',
            link: 'https://www.instagram.com/pixon_animasiya/'
        },
        {
            icon: 'fab fa-youtube',
            link: "https://www.youtube.com/@intiqamhuseynov/videos"
        },
        {
            icon: 'fas fa-video',
            link: 'https://videohive.net/user/vixelmotion/portfolio'
        },
    ],
    about: `Intigam Huseynov is a professional motion designer.
        <br /> He has been working in this field since 2009
        <br /> 13 years of work experience
        <br /> Currently, he is the head of Pixon animation studio
        <br /> Software knowledge: 3ds Max, Cinema 4D, After Effects & Zbrush`,
};
